import React, { useState } from "react";
import MerchantTopupPendingTable from "./MerchantTopup1";
import MerchantTopup1Copy from "./MerchantTopup1Copy";

const CashInTabs = () => {
    const [openPopup, setOpenPopup] = useState(null); // null | "cashin1" | "cashin2"

    const cards = [
        {
            key: "cashin1",
            label: "Cash In 1",
            sub: "Primary cash-in requests & approvals",
            color: "#0A2A4F",
            accent: "#1a4a7a",
            icon: (
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" />
                    <path d="M16 7V5a2 2 0 0 0-4 0v2" />
                    <line x1="12" y1="12" x2="12" y2="16" />
                    <line x1="10" y1="14" x2="14" y2="14" />
                </svg>
            ),
        },
        {
            key: "cashin2",
            label: "Cash In 2",
            sub: "Secondary cash-in requests & approvals",
            color: "#14532d",
            accent: "#166534",
            icon: (
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" />
                    <path d="M16 7V5a2 2 0 0 0-4 0v2" />
                    <circle cx="12" cy="14" r="2" />
                </svg>
            ),
        },
    ];

    return (
        <>
            {/* ── Landing — two big clickable cards ── */}
            <div className="w-full flex flex-col sm:flex-row gap-6 p-6">
                {cards.map((card) => (
                    <button
                        key={card.key}
                        onClick={() => setOpenPopup(card.key)}
                        className="flex-1 flex flex-col items-center justify-center gap-4 rounded-2xl py-14 px-8 text-white shadow-xl hover:scale-[1.02] active:scale-[0.99] transition-transform duration-200"
                        style={{
                            background: `linear-gradient(135deg, ${card.color} 0%, ${card.accent} 100%)`,
                            minHeight: "220px",
                            boxShadow: `0 8px 32px ${card.color}55`,
                        }}
                    >
                        {/* Icon bubble */}
                        <div
                            className="w-20 h-20 rounded-2xl flex items-center justify-center"
                            style={{ background: "rgba(255,255,255,0.15)" }}
                        >
                            {card.icon}
                        </div>

                        <div className="text-center">
                            <p className="text-[22px] font-bold leading-tight">{card.label}</p>
                            <p className="text-[13px] mt-1 opacity-70 leading-snug">{card.sub}</p>
                        </div>

                        <div
                            className="flex items-center gap-2 px-5 py-2 rounded-full text-[13px] font-semibold"
                            style={{ background: "rgba(255,255,255,0.18)" }}
                        >
                            Open
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6" />
                            </svg>
                        </div>
                    </button>
                ))}
            </div>

            {/* ── Popup for Cash In 1 ── */}
            {openPopup === "cashin1" && (
                <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#f0f4fa" }}>
                    {/* Popup header */}
                    <div
                        className="flex items-center justify-between px-6 py-4 shadow-md flex-shrink-0"
                        style={{ background: "linear-gradient(90deg, #0A2A4F 0%, #1a4a7a 100%)" }}
                    >
                        <div className="flex items-center gap-3">
                            <div
                                className="w-9 h-9 rounded-lg flex items-center justify-center"
                                style={{ background: "rgba(255,255,255,0.15)" }}
                            >
                                {cards[0].icon}
                            </div>
                            <div>
                                <p className="text-white font-bold text-[16px] leading-tight">Cash In 1</p>
                                <p className="text-white/60 text-[11px]">Primary cash-in requests & approvals</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setOpenPopup(null)}
                            className="flex items-center gap-2 px-4 py-2 rounded-lg text-[13px] font-semibold text-white transition"
                            style={{ background: "rgba(255,255,255,0.12)" }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.22)"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.12)"}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                            Close
                        </button>
                    </div>

                    {/* Scrollable content */}
                    <div className="flex-1 overflow-y-auto px-4 py-4">
                        <MerchantTopupPendingTable />
                    </div>
                </div>
            )}

            {/* ── Popup for Cash In 2 ── */}
            {openPopup === "cashin2" && (
                <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#f0f4fa" }}>
                    {/* Popup header */}
                    <div
                        className="flex items-center justify-between px-6 py-4 shadow-md flex-shrink-0"
                        style={{ background: "linear-gradient(90deg, #14532d 0%, #166534 100%)" }}
                    >
                        <div className="flex items-center gap-3">
                            <div
                                className="w-9 h-9 rounded-lg flex items-center justify-center"
                                style={{ background: "rgba(255,255,255,0.15)" }}
                            >
                                {cards[1].icon}
                            </div>
                            <div>
                                <p className="text-white font-bold text-[16px] leading-tight">Cash In 2</p>
                                <p className="text-white/60 text-[11px]">Secondary cash-in requests & approvals</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setOpenPopup(null)}
                            className="flex items-center gap-2 px-4 py-2 rounded-lg text-[13px] font-semibold text-white transition"
                            style={{ background: "rgba(255,255,255,0.12)" }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.22)"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.12)"}
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                            Close
                        </button>
                    </div>

                    {/* Scrollable content */}
                    <div className="flex-1 overflow-y-auto px-4 py-4">
                        <MerchantTopup1Copy />
                    </div>
                </div>
            )}

        </>
    );
};

export default CashInTabs;
